import { createContext, ReactElement, useContext, useMemo } from "react"

import TypeTestDetails from "../../../ttr/formPages/typeTestDetails/typeTestDetails"
import { TTRDeviceFormData } from "../../../ttr/types/providerTypes"
import { IDeviceFormContextValue } from "../../../types/providerTypes"
import { CreateV2GBundleContext } from "../providers/baseProviders/createV2GBundleProvider"

const BundleTTRTypeTestContext = createContext(
    {} as IDeviceFormContextValue<TTRDeviceFormData>
)

const TypeTestDetailsV2G = (): ReactElement => {
    const {
        currentIndex,
        setCurrentIndex,
        canEditManufacturer,
        ttrFormData,
        setTtrFormData,
        errors,
    } = useContext(CreateV2GBundleContext)

    const contextValue = useMemo(
        () => ({
            currentIndex,
            setCurrentIndex,
            canEditManufacturer,
            formData: ttrFormData,
            setFormData: setTtrFormData,
            onSubmit: async () => undefined,
            submitLoading: false,
            submitSuccessful: false,
            saveDraft: async () => undefined,
            saveDraftLoading: false,
            saveDraftSuccessful: false,
            formIsLoading: false,
            errors,
        }),
        [
            currentIndex,
            setCurrentIndex,
            canEditManufacturer,
            ttrFormData,
            setTtrFormData,
            errors,
        ]
    )

    return (
        <BundleTTRTypeTestContext.Provider value={contextValue}>
            <TypeTestDetails
                context={BundleTTRTypeTestContext}
                hideDraftAction
            />
        </BundleTTRTypeTestContext.Provider>
    )
}

export default TypeTestDetailsV2G
